import { createFeatureSelector, createSelector } from '@ngrx/store';

import { hasAnonymization } from '@app/collections/users';
import { getCompaniesEntities } from '@collections/companies/companies.selectors';
import { CandidateAdapter } from '@shared';

import { LAYOUT_TOKEN, LayoutState } from './layout.reducer';

export const getLayoutState = createFeatureSelector<LayoutState>(LAYOUT_TOKEN);

export const getHeaderState = createSelector(getLayoutState, (state: LayoutState) => !!state && state.header);

export const getGlobalSearchResultJobs = createSelector(getHeaderState, (header) => header?.jobs);

export const getGlobalSearchResultCandidates = createSelector(getHeaderState, hasAnonymization, (header, anonymization: boolean) =>
  header?.candidates.map((candidate) => new CandidateAdapter(candidate, anonymization)),
);

export const getGlobalSearchResultCompanies = createSelector(getHeaderState, (header) => header?.companies);

export const getGlobalSearchResults = createSelector(
  getGlobalSearchResultJobs,
  getGlobalSearchResultCandidates,
  getGlobalSearchResultCompanies,
  (jobs, candidates, companies) =>
    candidates &&
    jobs &&
    companies && {
      candidates,
      jobs,
      companies,
    },
);

export const getGlobalSearchResultsWithCompanies = createSelector(getGlobalSearchResults, getCompaniesEntities, (outcome, companies) => {
  const jobsWithCompanies = outcome.jobs.map((job) => {
    const companyId = job.companyId;
    return {
      ...job,
      company: companies[companyId],
    };
  });
  return {
    ...outcome,
    jobs: jobsWithCompanies,
  };
});

/**
 * In case data was loaded in desktop, cut extra results out of the existing state
 * Limit arrays to 3 items
 */
export const getGlobalSearchResultsWithCompaniesMobile = createSelector(
  getGlobalSearchResultsWithCompanies,
  (header) =>
    !!header && {
      candidates: header.candidates.slice(0, 3),
      jobs: header.jobs.slice(0, 3),
      companies: header.companies.slice(0, 3),
    },
);

export const getGlobalSearchLoading = createSelector(getHeaderState, (header) => !!header && header.loading);

export const getGlobalSearchPhrase = createSelector(getHeaderState, (header) => !!header && header.search);
